<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="full-card" :style="isAdmin ? 'width: 80vw !important' : 'width: 60vw !important'">
      <q-toolbar class="auto-height horizontal-line">
        <div class="row q-pl-sm q-pt-sm text-subtitle1 text-bold" v-if="form._id">
          テンプレート編集中(ID:{{ form._id }})
        </div>
      </q-toolbar>
      <q-card-section>
        <div class="max-height-dialog double-title row">
          <div class="column col title-plus">
            <PreviewPanel
              ref="previewPanel"
              v-model="form.contents"
              :hoverPath="hoverPath"
              :isAdmin="isAdmin"
              :isSuper="isSuper"
              :errorPath="errorPath"
              :isChanged="isChanged"
              :altText="form.alt_text"
              @update:hoverPath="(args) => (hoverPath = args)"
              @initMessage="onInitMessage"
              @onSelectNode="onSelectNodeFromPreview"
              @captureMessage="(file, url) => $emit('captureMessage', file, url)"
            />
          </div>
          <div class="column col title-plus" v-if="isAdmin">
            <TreePanel
              ref="treePanel"
              v-model="form.contents"
              :errorPath="errorPath"
              :isAdmin="isAdmin"
              @onSelectNode="onSelectNode"
              @onHoverNode="onHoverNode"
            />
          </div>
          <div class="col column justify-between title-plus">
            <div>
              <q-toolbar class="auto-height horizontal-line">
                <q-toolbar-title class="q-pa-sm"> Poti-Potiフレックス </q-toolbar-title>
                <q-btn flat round dense icon="close" @click="onCancel" />
              </q-toolbar>
            </div>
            <FormPanel
              v-model="form.contents"
              :altText="form.alt_text"
              :selectedPath="selectedPath"
              :nodePath="nodePath"
              :isAdmin="isAdmin"
              @update:altText="(val) => (form.alt_text = val)"
              @update:validateValue="onValidate"
              ref="formPanel"
            />
            <div class="row no-wrap items-center q-my-md q-pr-md">
              <q-space />
              <div class="q-gutter-sm">
                <q-btn no-caps flat class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
                <q-btn no-caps class="btn-save" @click="onSubmit"> {{ $t('save') }} </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel, IFlexMessageTemplate } from '@/utils/types'
import TreePanel from '@/components/common/flex-message/TreePanel.vue'
import FormPanel from '@/components/common/flex-message/FormPanel.vue'
import cloneDeep from 'lodash/cloneDeep'

@Options({
  components: { FormPanel, TreePanel },
  directives: { maska },
  emits: ['update:altText', 'update:template', 'captureMessage'],
})
export default class FlexMessageTemplateEditModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  altText!: string

  @Prop()
  template!: IFlexMessageTemplate

  @Prop()
  appId!: string

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  hoverPath = ''
  selectedPath = ''
  nodePath = []
  errorPath: string[] = []
  form: IFlexMessageTemplate = {
    _id: '',
    app_id: this.appId,
    name: '',
    img: '',
    description: '',
    type: 'bubble',
    is_video: false,
    is_image: true,
    is_button: false,
    contents: {},
    alt_text: '',
  }

  onInitMessage(message: IFlexMessageBubble | IFlexMessageCarousel) {
    this.errorPath = []
    if (this.isAdmin) {
      this.$nextTick(() => {
        this.$refs.treePanel.initMessage(message)
      })
    }
  }

  onSelectNode(path, nodePath) {
    this.selectedPath = path
    this.nodePath = nodePath
  }

  onSelectNodeFromPreview(path, node, nodePath) {
    if (this.errorPath.length === 0) {
      this.onSelectNode(path, nodePath)
      if (this.isAdmin) {
        this.$nextTick(() => {
          this.$refs.treePanel.onSelectNode(node, path)
        })
      }
    }
  }

  onHoverNode(path) {
    this.hoverPath = path
  }

  onValidate(val) {
    const index = this.errorPath.indexOf(this.selectedPath)

    if (!val) {
      if (index === -1) {
        this.errorPath.push(this.selectedPath)
      }
    } else {
      if (index !== -1) {
        this.errorPath.splice(index, 1)
      }
    }
  }

  async onSubmit() {
    if (this.errorPath.length === 0 && this.form.alt_text !== '') {
      this.$emit('update:altText', this.form.alt_text)
      this.$emit('update:template', this.form)
      if (this.isChanged) {
        this.$refs.previewPanel.captureMessage()
        setTimeout(() => {
          this.visible = false
        }, 300)
      } else {
        this.visible = false
      }
    }
    if (this.form.alt_text === '') {
      this.$q.notify({
        type: 'negative',
        message: this.$t('validate.this_field_is_required', {
          placeholder: this.$t('label.common.answer.alt_text'),
        }),
      })
    }
  }

  mounted() {
    this.form = { ...this.form, ...cloneDeep(this.template) }
    if (!this.form.alt_text) {
      this.form.alt_text = this.altText
    }
    // eslint-disable-next-line
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
  }

  beforeCreate() {
    const components = this.$options?.components
    if (components) {
      ;(components as any).PreviewPanel = require('@/components/common/flex-message/PreviewPanel.vue').default
    }
  }
}
</script>

<style scoped lang="scss">
.max-height-dialog {
  height: calc(100vh - 37px);
  overflow-x: auto;
}
</style>
